module.exports = __webpack_public_path__ + "components/country-flag/static/sk-d5297d7b66162772ca4326ec1a00f4df.svg";